export type FailureRow = { arquivo: string; falha: string }

export interface FailureFiles {
  adherence: string
  selection: string
  // PSV-424: nome do Mapa de Atendimento, quando o processamento tem um.
  serviceMap?: string | null
}

/**
 * Separa o `dsErrorLog` em linhas "arquivo → falha" para a tabela de
 * detalhes. O backend marca a origem da falha com o rótulo entre colchetes
 * (`[Adesão]`, `[Seleção]`, `[Mapa de Atendimento]`); sem rótulo, a falha é
 * atribuída a todos os arquivos recebidos.
 */
export const parseFailures = (
  dsErrorLog: string | null | undefined,
  files: FailureFiles
): FailureRow[] => {
  if (!dsErrorLog) return []
  try {
    const parsed = JSON.parse(dsErrorLog)
    if (Array.isArray(parsed)) return parsed as FailureRow[]
  } catch {
    // fall through
  }
  const serviceMap = files.serviceMap ?? ''
  const fileMap: Record<string, string> = {
    adesão: files.adherence,
    adesao: files.adherence,
    seleção: files.selection,
    selecao: files.selection,
    ...(serviceMap ? { 'mapa de atendimento': serviceMap } : {}),
  }
  const bracketRegex = /\[([^\]]+)\]\s*([^[]+)/g
  const rows: FailureRow[] = []
  let match: RegExpExecArray | null
  while ((match = bracketRegex.exec(dsErrorLog)) !== null) {
    const key = match[1].trim().toLowerCase()
    const falha = match[2].trim()
    if (falha) {
      rows.push({ arquivo: fileMap[key] ?? match[1].trim(), falha })
    }
  }
  if (rows.length > 0) return rows
  return [
    {
      arquivo: [files.adherence, files.selection, serviceMap]
        .filter(Boolean)
        .join('; '),
      falha: dsErrorLog,
    },
  ]
}
